<template>
  <Modal v-model="returnedReasonModal" :title="$t('key1000640')" width="450" :transfer="false" :mask-closable="false"
    @on-visible-change="returnedReasonChange">
    <Form ref="returnedReasonForm" :model="returnedReasonForm" :rules="ruleValidate" :label-width="80" @submit.native.prevent>
      <Row style="width: 90%;">
        <h2 class="mb12">{{ $t('key1000643') }}</h2>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000641')" prop="conent">
            <Input
              type="textarea"
              :placeholder="$t('key1000642')"
              :autosize="{ minRows: 3, maxRows: 5}"
              v-model.trim="returnedReasonForm.conent">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="returnedReasonModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="returnedReasonBtn">{{ $t('key1000640') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "returnedReasonModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      returnedReasonModal: false,
      returnedReasonForm: {
        conent: null
      },
      ruleValidate: {
        conent: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000639'), trigger: 'blur'}
        ],
      },
    };
  },
  created() {

  },
  methods: {
    // 监听退回弹窗
    returnedReasonChange(value) {
      if (!value) {
        this.returnedReasonForm.conent = '';
        this.$nextTick(() => {
          this.$refs['returnedReasonForm'].resetFields();
        });
      }
    },
    // 退回
    returnedReasonBtn() {
      let v = this;
      v.$refs['returnedReasonForm'].validate((valid) => {
        if (valid) {
          v.$emit('returnedReasonBtn', this.returnedReasonForm.conent);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>

</style>